// These choices come from the current Create and Update Member design.
// Stored answers remain unchanged until the user edits the corresponding field.
export const memberHearAboutOptions = [
  "Referred by a member", "Chamber event", "Web search", "Social media",
  "Local advertising", "Chamber staff outreach", "Word of mouth", "Other",
];

export const memberReasonForJoiningOptions = [
  "Networking opportunities", "Business visibility & marketing", "Member discounts & perks",
  "Advocacy & representation", "Community involvement", "Professional development",
  "Access to chamber events", "Other",
];

export const updateMemberSocialPlatforms = (previous: string[], selected: string[]): string[] => {
  // Only a new choice applies exclusivity. Do not normalize saved legacy values on load.
  if (selected.includes("None") && !previous.includes("None")) return ["None"];
  if (selected.some((platform) => platform !== "None" && !previous.includes(platform))) {
    return selected.filter((platform) => platform !== "None");
  }
  return selected.includes("None") ? ["None"] : selected;
};
